import { TransactionStatus } from 'enums';

export const getSeverityFromStatus = (status) => {
    switch (status) {
        case TransactionStatus.submitted:
            return 'info';
        case TransactionStatus.paid:
            return 'success';
        case TransactionStatus.canceled:
            return 'error';
        case TransactionStatus.rechecked:
            return 'info';
        case TransactionStatus.pendingPayment:
            return 'info';
        case TransactionStatus.pending:
            return 'warning';
        default:
            throw new Error('Invalid status');
    }
};
